import React from 'react';
import { endorsements } from '../data/portfolio';
import { Label } from './Label';
export function PublicRecord() {
  return <section id="record" aria-labelledby="record-heading" className="scroll-mt-20 bg-ink px-6 py-24 md:px-10 md:py-32" data-id="element-182" data-mp="1im34f572hmy5">
      <div className="mx-auto w-full max-w-edge" data-id="element-183" data-mp="18oom101l2o37">
        <Label data-id="element-184" data-mp="18q00btsnne8k">Public Record</Label>

        <h2 id="record-heading" className="mt-10 max-w-3xl font-display text-3xl font-normal leading-[1.14] text-paper md:text-[3rem]" data-id="element-185" data-mp="18r1cy2pbk8se">
          What the public record says
        </h2>
        <p className="mt-7 max-w-2xl text-base leading-relaxed text-stone md:text-lg" data-id="element-186" data-mp="1wmnijo21eulb">
          Independent supporting evidence — published statements from the board that appointed him.
        </p>

        <ol className="mt-16 max-w-4xl border-t border-white/15" data-id="element-187" data-mp="2p2yd41x7mqxq">
          {endorsements.map(endorsement => <li key={endorsement.quote} className="border-b border-white/15 py-10" data-id="element-188" data-mp="2kbpzsusrelfa">
              <blockquote className="font-display text-xl font-normal leading-[1.5] text-paper md:text-[1.6rem]" data-id="element-189" data-mp="mdo7v0n95ty9">
                “{endorsement.quote}”
              </blockquote>
              <p className="mt-6 text-[0.75rem] uppercase tracking-[0.22em] text-fog" data-id="element-190" data-mp="qguazzf2j50i">
                {endorsement.source} · {endorsement.context}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}